import React, { useContext, useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { DetailsContext } from '../contexts/DetailsContext'

const Navbar = () => {
    const [small, setSmall] = useState(true)
      const { adminUser, setAdminUser } = useContext(DetailsContext)
    const checkDocumentWidth = () => {
        if (document.documentElement.clientWidth > 600) {
          setSmall(false);
        } else {
          setSmall(true);
        }
      };
      useEffect(() => {
        // Initial check when the component mounts
        checkDocumentWidth();
    
        // Listen for window resize events
        window.addEventListener('resize', checkDocumentWidth);
    
        // Clean up the event listener on component unmount
        return () => {
          window.removeEventListener('resize', checkDocumentWidth);
        };
      }, []);

  return (
    <div id={(small) ?  'nav' : 'na'} className={`w3-container ${(small) ? 'collapse' : 'w3-show'} w3-bar my-scroll-div w3-top w3-col l3 m3 s5`}>
      <div className="w3-panel">
        <p className='w3-medium logo'>ADMIN</p>
      </div>
      <div className='w3-bar flex-column'>
        <NavLink to='/dashboard' end className="w3-row navi flex-row w3-padding link w3-round-large">
            <p className='w3-large margin-0'>
                <i class="fa-solid fa-gauge"></i>
            </p>
            <p className='w3-medium w3-padding margin-0'>Dashboard</p>
        </NavLink>
        <div style={{width: '100%'}} className="w3-row w3-bar-item">
        <p className='w3-text-grey bold margin-0'>Generals</p>
        </div>
        <NavLink to='/users' end className="w3-row navi flex-row w3-padding link w3-round-large">
            <p className='w3-large margin-0'>
            <i class="fa-solid fa-user"></i>
            </p>
            <p className='w3-medium w3-padding margin-0'>Users</p>
        </NavLink>
        <NavLink to='/complaints' end className="w3-row navi flex-row w3-padding link w3-round-large">
            <p className='w3-large margin-0'>
            <i class="fa-solid fa-suitcase-rolling"></i>
            </p>
            <p className='w3-medium w3-padding margin-0'>Complaints</p>
        </NavLink>
        <NavLink to='/verified' end className="w3-row navi flex-row w3-padding link w3-round-large">
            <p className='w3-large margin-0'>
            <i class="fa-solid fa-user-tie"></i>
            </p>
            <p className='w3-medium w3-padding margin-0'>Verified</p>
        </NavLink>
        {adminUser && adminUser.role == 'CEO' && <NavLink to='/admin' end className="w3-row navi flex-row w3-padding link w3-round-large">
            <p className='w3-large margin-0'>
            <i class="fa-solid fa-user-secret"></i>
            </p>
            <p className='w3-medium w3-padding margin-0'>Admins</p>
        </NavLink>}
        
        <NavLink to='/transaction' className="w3-row navi flex-row w3-padding link w3-round-large">
            <p className='w3-large margin-0'>
            <i class="fa-solid fa-receipt"></i>
            </p>
            <p className='w3-medium w3-padding margin-0'>Transactions</p>
        </NavLink>
        <div style={{width: '100%'}} className="w3-row w3-bar-item">
          <p className='w3-text-grey bold margin-0'>Controls</p>
        </div>
        <NavLink to='/gateway' className="w3-row navi flex-row w3-padding link w3-round-large">
            <p className='w3-large margin-0'>
            <i class="fa-solid fa-coins"></i>
            </p>
            <p className='w3-medium w3-padding margin-0'>Payment</p>
        </NavLink>
        <NavLink to='/country' className="w3-row navi flex-row w3-padding link w3-round-large">
            <p className='w3-large margin-0'>
            <i class="fa-solid fa-earth-americas"></i>
            </p>
            <p className='w3-medium w3-padding margin-0'>Countries</p>
        </NavLink>
        <NavLink to='/cost' className="w3-row navi flex-row w3-padding link w3-round-large">
            <p className='w3-large margin-0'>
            <i class="fa-solid fa-hand-holding-dollar"></i>
            </p>
            <p className='w3-medium w3-padding margin-0'>Costs</p>
        </NavLink>
        <div style={{width: '100%'}} className="w3-row w3-bar-item">
          <p className='w3-text-grey bold margin-0'>Income Services</p>
        </div>
        <NavLink to='/sms' className="w3-row navi flex-row w3-padding link w3-round-large">
            <p className='w3-large margin-0'>
            <i class="fa-solid fa-coins"></i>
            </p>
            <p className='w3-medium w3-padding margin-0'>Monetization</p>
        </NavLink>
    </div>
    </div>
    
  )
}

export default Navbar